







import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component
export default class HonjoSteps extends Vue {
  @Prop(Number) active!: number

  @Prop(Boolean) process!: boolean // 纯进度条模式

  get processCls () {
    return this.process ? 'honjo-steps--process' : ''
  }
}
